import { MoveSheetNormalized } from '@/modules/move/entities';
import { MOVE_SHEET_COLUMN } from '@/modules/move/entities/constants/moveSheetColumn';

export const checkIfValueIsSomeWithError = (
  key: MOVE_SHEET_COLUMN,
  originalRow: MoveSheetNormalized | null,
) => {
  return (value: string) => {
    const originalRowColumn = originalRow?.content?.find(
      (content) => content.key === key && content.hasError,
    );
    if (originalRowColumn?.value === value) {
      return originalRowColumn.messages.map((message) => message.value).join(' | ');
    }

    return null;
  };
};
